import { makeObservable, observable, action, computed, runInAction } from 'mobx'
/**
 * AppTypeStore manages the current application type ('client' or 'team'),
 * persists it to localStorage, and exposes handy computed flags.
 *
 * @class AppTypeStore
 * @param {object} rootStore - Reference to the root MobX store.
 */
class AppTypeStore {
	type = ''
	constructor(rootStore) {
		this.rootStore = rootStore
		makeObservable(this, {
			type: observable,
			appIs: computed,
			appIsClient: computed,
			appIsTeam: computed,
			setAppType: action.bound,
			toggleAppType: action.bound
		})

		// Load initial state from localStorage
		this.loadState()
	}
	/**
	 * @action
	 * @description Loads the state from localStorage.
	 */
	loadState() {
		const state = JSON.parse(localStorage.getItem('appType'))
		if (state) {
			this.setAppType(state)
		}
	}

	/**
	 * Indicates whether the current app type is 'client'.
	 *
	 * @computed
	 * @returns {boolean}
	 */
	get appIsClient() {
		return this.type === 'client'
	}

	/**
	 * Indicates whether the current app type is 'team'.
	 *
	 * @computed
	 * @returns {boolean}
	 */
	get appIsTeam() {
		return this.type === 'team'
	}

	/**
	 * Returns the raw app type value.
	 *
	 * @computed
	 * @returns {string} - Current app type.
	 */
	get appIs() {
		return this.type
	}

	/**
	 * Sets the application type and persists it.
	 *
	 * @action
	 * @param {string} value - The new app type ('client' or 'team').
	 */
	setAppType(value) {
		runInAction(() => {
			if (this.type !== value) {
				this.type = value
				localStorage.setItem('appType', JSON.stringify(value))
			}
		})
	}

	/**
	 * Toggles the app type between 'client' and 'team'.
	 *
	 * @action
	 */
	toggleAppType() {
		this.setAppType(this.type === 'client' ? 'team' : 'client')
	}
}

export default AppTypeStore
